import React, { PropsWithChildren, useMemo } from 'react'
import { useAtomValue } from 'jotai'
import {
  ConnectionProvider,
  WalletProvider
} from '@solana/wallet-adapter-react'
import { WalletModalProvider } from '@solana/wallet-adapter-react-ui'

import { rpcEndpointAtom } from '@/stores/settings'

import { wallets } from '../adapters'
import SelectWalletModal from '../components/SelectWalletModal'

const SolanaProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const rpcEndpoint = useAtomValue(rpcEndpointAtom)

  return (
    <ConnectionProvider endpoint={rpcEndpoint}>
      <WalletProvider wallets={wallets} autoConnect>
        <WalletModalProvider>
          {children}
          <SelectWalletModal />
        </WalletModalProvider>
      </WalletProvider>
    </ConnectionProvider>
  )
}

export default SolanaProvider
